import { RestClient } from '@/api/rest-client'
import { BranchTarget } from '@/api/model/branch-target'
import { Pipeline } from '@/api/model/pipeline'
import { cloneDeep } from 'lodash'

export class BranchTargetClient extends RestClient<BranchTarget> {
    collectionName = 'branch_targets'
    parseData = BranchTarget.fromData

    async create(data: BranchTarget): Promise<BranchTarget> {
        const request = cloneDeep<any>(data)

        if (data.referralPipeline instanceof Pipeline) {
            request.referralPipeline = data.referralPipeline.resourceIdentifier
        }

        return super.create(request)
    }

    async update(id: string, data: BranchTarget): Promise<BranchTarget> {
        const request = cloneDeep<any>(data)

        if (data.referralPipeline instanceof Pipeline) {
            request.referralPipeline = data.referralPipeline.resourceIdentifier
        }

        return super.update(id, request)
    }
}
